<template>
  <div class="lesson-major">
    <div class="lesson-major-type container">
      <div class="cates">
        <!-- <div class="major-item" v-for="item in tags" :key="item.id">
          <el-row>
            <el-col :span="1">
              <div class="major-title">{{ item.name }}：</div>
            </el-col>
            <el-col :span="23">
              <common-tags class="region-box" :list="item.list" :props="item.props" :value.sync="item.value" :show-more="item.showMore" :change="changeMajor" />
            </el-col>
          </el-row>
        </div> -->
        <div class="organ-type">
          <el-row>
            <el-col :span="1">
              <div class="organ-title">类型：</div>
            </el-col>
            <el-col :span="23">
              <radio-group-btn class="radio-group-tag" :data="group1" name="group1" :default-value="searchForm.publicFlag || 'all'" :change="changeType" />
            </el-col>
          </el-row>
        </div>
        <div class="organ-type">
          <el-row>
            <el-col :span="1">
              <div class="organ-title">排序：</div>
            </el-col>
            <el-col :span="21">
              <radio-group-btn class="radio-group-tag" :data="group2" name="group2" :default-value="searchForm.sidx" :change="changeOrder" />
            </el-col>
            <el-col :span="2">
              <el-button round size="mini" type="primary" @click="joinPLesson">加入课堂</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="dept-brief container">
      <div class="dept-cates">
        <is-empty :show="labList.length > 0" message="暂时没有数据~">
          <div class="lesson-items-container clear-both">
            <div class="lesson" v-for="item in labList" :key="item.lessonId" @click="handleClickLesson(item)">
              <a class="lesson-box">
                <div class="sign-box" @click.stop="handleClickDetail(item)">
                  <span>查看详情</span>
                </div>
                <div class="lesson-img">
                  <el-image fit="cover" :src="item.avatar | filterUrl" style="width: 100%; height: 100%">
                    <div class="image-placeholder" slot="placeholder">
                      <i class="el-icon-loading"></i>
                    </div>
                    <div class="image-error" slot="error">
                      <div style="width: 100%; height: 100%; background: #e1ebf0; text-align: center">
                        <el-image :src="require('@/assets/imgs/error_image.png')" style="width: 84px; height: 60px; margin-top: 42px"></el-image>
                      </div>
                    </div>
                  </el-image>
                </div>
                <div class="lesson-body clear-both">
                  <div class="lesson-name" v-text="item.lessonName"></div>
                  <div class="lesson-desc" v-text="item.summary"></div>
                  <div class="lesson-footer">
                    <span>任课教师：{{ item.teacher }}</span>
                    <div class="lesson-footer-score">
                      <span v-if="item.credits">
                        <el-tag size="mini">{{ `${item.credits}学分` }}</el-tag>
                      </span>
                      <span v-if="item.periods">
                        <el-tag size="mini">{{ `${item.periods}课时` }}</el-tag>
                      </span>
                      <span class="lesson-per-num" style="padding: 0"> <i class="icon icon-user-organization"></i>{{ item.memberNum }} </span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="lab-list-page">
            <el-pagination
              background
              prev-text="上一页"
              next-text="下一页"
              layout="prev, pager, next"
              :total="page.total"
              :current-page="page.currentPage"
              :page-size="page.pageSize"
              @current-change="handlePageChange"
            >
            </el-pagination>
          </div>
        </is-empty>
        <el-dialog title="加入课堂" :visible.sync="open" width="500px">
          <el-form ref="form" :model="form" :rules="rules" label-width="80px">
            <el-form-item label="邀请码" prop="code">
              <el-input v-model="form.code" placeholder="请输入课堂邀请码"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="open = false">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog :title="this.title" center :visible.sync="flag" width="840px" class="lesson-exp-detail">
          <el-row :gutter="12">
            <el-col :span="12" v-for="(item, index) in expData" :key="item.uid" class="exp-item">
              <span v-text="`${(labExpPage.page - 1) * labExpPage.limit + index + 1}、${item.name}`"></span>
            </el-col>
          </el-row>
          <span slot="footer" class="dialog-footer">
            <el-pagination background layout="prev, pager, next" :current-page="labExpPage.page" :page-size="labExpPage.limit" :total="labExpPage.total" @current-change="handleLabExpPageChange">
            </el-pagination>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getAllList, checkLesson, joinPublicLesson, joinPrivateLesson } from "@/api/lab/lesson";
// import commonTags from '@/components/common/tags'
import radioGroupBtn from "@/components/common/radio-group-btn";
import isEmpty from "../../../components/common/is-empty.vue";
import { getLabExpsNoToken } from "@/api/lab/experiment";
import { open_blank } from "@/utils/router";
export default {
  data() {
    return {
      page: {
        currentPage: 1, // 当前页
        pageSize: 12, // 每页条目数
      },
      labExpPage: {
        lessonUid: "",
        total: 0,
        page: 1,
        limit: 6,
      },
      labelId: "",
      title: "",
      flag: false,
      open: false,
      form: {},
      expData: [],
      labList: [],
      searchForm: {
        likeName: null, // 模糊查询课程名称、教师、描述...
        majorName: null, // 专业分类名称
        labelName: null, // 专业(课程)名称
        publicFlag: "0", // 课堂类型
        sidx: "ll.create_time desc", // 排序字段
      },
      tags: [
        {
          id: 1,
          name: "专业",
          showMore: false,
          show: false,
          value: 0,
          props: {
            label: "dictValue",
            value: "id",
          },
          list: [{ id: 0, dictValue: "全部" }],
        },
      ],
      rules: {
        code: [{ required: true, message: "请输入邀请码", trigger: "blur" }],
      },
      group1: [
        // { text: '全部', value: 'all' },
        { text: "公开课", value: "0" },
        // { text: '一流课程', value: '2' }
      ],
      group2: [
        { text: "综合", value: "ll.id desc" },
        { text: "最新", value: "ll.create_time desc" },
        // { text: '最热', value: 'num desc' }
      ],
    };
  },
  components: {
    radioGroupBtn,
    // commonTags,
    isEmpty,
  },
  computed: {
    ...mapGetters(["token"]),
    ...mapGetters("course", ["majorTreeList"]),
  },
  watch: {
    $route: {
      // deep: true,
      immediate: true,
      handler: function (newVal) {
        const { query } = newVal;
        let { type, labelId, majorOrLabel, majorName, majorValue } = query;
        if (type == null) {
          type = '0'
        }
        if (type instanceof Number) {
          type = String(type)
        }
        if (labelId == null) {
          labelId = '0'
        }
        if (labelId instanceof Number) {
          labelId = String(labelId)
        }
        if (majorValue == null || majorValue === '') {
          majorValue = 0
        }
        this.labelId = labelId;
        this.searchForm.likeName = majorOrLabel;
        this.searchForm.majorName = majorName;
        this.searchForm.publicFlag = type === "all" ? null : type.toString();
        if (Number(this.labelId) > 0) {
          let row = this.majorTreeList.find((item) => item["dictList"].some((subItem) => subItem[this.tags[0].props.value] === Number(this.labelId)));
          let subRow = row["dictList"].find((item) => item[this.tags[0].props.value] === Number(this.labelId));
          this.tags[0].value = row[this.tags[0].props.value];
          this.searchForm.labelName = subRow[this.tags[0].props.label];
        } else {
          this.tags[0].value = majorValue;
        }
      },
    },
  },
  methods: {
    ...mapActions(["setLoginVisible"]),
    ...mapActions("course", {
      getTags: "selectCourseMajorDict",
    }),
    changeMajor(type) {
      let majorName = null;
      let list = {};
      list = {
        ...list,
        ...this.tags[0],
      };
      list.list.map((item) => {
        if (type === item[this.tags[0].props.value || "value"]) {
          majorName = item[this.tags[0].props.label || "label"];
        } else if (type === 0) {
          majorName = null;
        }
      });
      this.searchForm.labelName = null;
      this.searchForm.majorName = majorName;
      this.$router.push({
        name: "lessonMajor",
        query: {
          type: this.searchForm.publicFlag || "all",
          majorValue: type,
          majorName,
        },
      });
    },
    changeType(type) {
      this.searchForm.publicFlag = type === "all" ? null : type;
      this.$router.push({
        name: "lessonMajor",
        query: {
          type,
          labelId: String(this.labelId),
          majorValue: String(this.tags[0].value),
          majorName: this.searchForm.majorName || null,
        },
      });
    },
    changeOrder(sidx) {
      this.searchForm.sidx = sidx;
      this.getLabList();
    },
    initCourseMajorTags() {
      this.tags[0].list = [
        {
          id: 0,
          dictValue: "全部",
        },
        ...this.majorTreeList,
      ];
    },
    //剔除南昌航空的课程ID
    removeArrItem(arr, uid = 'acac20574b274bb4831e003e762b0da2'){
        var Arr = []
        arr.map(item => {
            if(item.uid !== uid) Arr.push(item)
        })
        return Arr
    },
    getLabList(params = {}) {
      getAllList(this.page.currentPage, this.page.pageSize, {
        ...this.searchForm,
        ...params,
        delFlag: "0",
      })
        .then((data) => {
          if (data) {
            this.page = {
              currentPage: data.currPage, // 当前页
              pageSize: data.pageSize, // 每页条目数
              total: data.totalCount,
            };
            this.labList = this.removeArrItem(data.list)
          }
        })
        .catch(() => {
          this.labList = [];
        });
    },
    handleClickLesson(item) {
      const { uid, lessonName, publicFlag } = item;
      if (publicFlag === 2) {
        // 申报课堂
        // 在新标签页中打开申报页面
        open_blank({
          name: "shenbaoV1",
          params: {
            key: item.keyUrl,
          },
        });
        return;
      }
      if (!this.token) this.setLoginVisible(true);
      else {
        // 判断实验课堂的状态，是否可进入
        checkLesson(uid).then((res) => {
          if (res == 3) {
            // 询问是否想要加入该课堂
            this.$confirm(`是否加入课堂"${lessonName}"`, "提 示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            })
              .then(() => {
                joinPublicLesson(uid)
                  .then(() => {
                    this.$message.success("加入成功！");
                  })
                  .catch((err) => {
                    window.console.error(err);
                  });
              })
              .catch(() => {});
          } else this.$router.push(`/lesson/${uid}/type/exp`);
        });
      }
    },
    // 点击“加入私有课”按钮
    joinPLesson() {
      if (!this.token) {
        this.setLoginVisible(true);
      } else {
        this.open = true;
        this.form = {};
      }
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { code } = this.form;
          const newCode = code.trim();
          this.open = false;
          // 使用邀请码加入课堂
          joinPrivateLesson(newCode).then((uid) => {
            this.$message.success("加入成功！");
            this.$router.push(`/lesson/${uid}/type/exp`);
          });
        } else {
          return false;
        }
      });
    },
    handleClickDetail(item) {
      this.title = item.lessonName;
      this.initExpList(item.uid);
    },
    // currentPage 改变时会触发
    handlePageChange(page) {
      this.$set(this.page, "currentPage", page);
      this.getLabList();
    },
    // 获取课堂实验列表
    async initExpList(uid) {
      const { labExpPage } = this;
      const { limit = 6, lessonUid } = labExpPage;
      let { page = 1 } = labExpPage;
      let arr = [];
      let total = 0;
      if (!uid) uid = lessonUid;
      if (lessonUid !== uid) {
        page = 1;
        this.$set(this.labExpPage, "page", 1);
      }
      await getLabExpsNoToken(page, limit, {
        lessonUid: uid,
        sidx: "view_index, create_time DESC",
      }).then(({ totalCount, list }) => {
        total = totalCount;
        arr = list;
      });
      this.$set(this.labExpPage, "total", total);
      this.$set(this.labExpPage, "lessonUid", uid);
      this.expData = arr;
      if (arr.length > 0) this.flag = true;
    },
    handleLabExpPageChange(page) {
      this.$set(this.labExpPage, "page", page);
      this.initExpList();
    },
  },
  created() {
    if (this.majorTreeList.length < 1) {
      this.getTags()
        .then(() => {})
        .catch(() => {})
        .finally(() => {
          this.initCourseMajorTags();
        });
    } else {
      this.initCourseMajorTags();
    }
    this.getLabList();
  },
};
</script>

<style lang="scss">
.lesson-major {
  .lesson-exp-detail {
    .el-dialog {
      background: url("~@/assets/imgs/background-text.png") no-repeat;
      background-size: cover;
      border-radius: 24px;
      .el-dialog__close {
        color: #fff;
      }
      .el-dialog__header {
        padding: 30px 20px 60px 20px;
        .el-dialog__title {
          color: #fff;
        }
      }
      .el-dialog__body {
        .el-row {
          .exp-item {
            height: 96px;
            margin-bottom: 12px;
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            span {
              width: 80%;
            }
          }
          > div:nth-of-type(1) {
            background: url("~@/assets/imgs/bg-text1.png") no-repeat;
            color: #5a5a14;
          }
          > div:nth-of-type(2) {
            background: url("~@/assets/imgs/bg-text2.png") no-repeat;
            color: #3c501e;
          }
          > div:nth-of-type(3) {
            background: url("~@/assets/imgs/bg-text3.png") no-repeat;
            color: #3c6e32;
          }
          > div:nth-of-type(4) {
            background: url("~@/assets/imgs/bg-text4.png") no-repeat;
            color: #286464;
          }
          > div:nth-of-type(5) {
            background: url("~@/assets/imgs/bg-text5.png") no-repeat;
            color: #3c6496;
          }
          > div:nth-of-type(6) {
            background: url("~@/assets/imgs/bg-text6.png") no-repeat;
            color: #7d46a0;
          }
          > div:nth-of-type(7) {
            background: url("~@/assets/imgs/bg-text7.png") no-repeat;
            color: #8c3c82;
          }
          > div:nth-of-type(8) {
            background: url("~@/assets/imgs/bg-text8.png") no-repeat;
            color: #8d4866;
          }
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
@import "~@/assets/css/lesson-major.less";
.lesson-major {
  margin-top: 24px;
  .lesson-major-type {
    background-color: #fff;
    padding: 48px 24px 24px 24px;

    .organ-title {
      margin-top: 4px;
      display: inline-block;
    }
    .organ-type {
      font-size: 14px;
      margin-bottom: 15px;
      .radio-group-tag {
        font-size: 14px !important;
      }
    }
  }
}
</style>
